import Button from '@mui/material/Button';
import DialogContentText from '@mui/material/DialogContentText';
import React from 'react';
import Modal from './Modal';

type ConfirmDialogOpener = (props: ConfirmDialogProps) => void;

export let openConfirmDialogExternal: ConfirmDialogOpener = () => undefined;

type ButtonType = 'success' | 'inherit' | 'primary' | 'secondary' | 'error' | 'info' | 'warning';

type ConfirmDialogProps = {
  title: string;
  message: string;
  type?: ButtonType;
  buttonText?: string;
  onAnswer: (answer: boolean) => void;
};

type State = {
  open: boolean;
  title: string;
  message: string;
  type?: ButtonType;
  buttonText?: string;
  onAnswer: (answer: boolean) => void;
};

class Confirmer extends React.Component<unknown, State> {
  constructor(props: unknown) {
    super(props);

    this.state = {
      open: false,
      title: 'Are you sure?',
      message: '',
      onAnswer: () => undefined,
      type: 'success',
      buttonText: 'OK',
    };

    openConfirmDialogExternal = this.openConfirmDialog;
  }

  public render() {
    return (
      <Modal
        open={this.state.open}
        onClose={this.handleClose}
        closeLabel="Close"
        title={this.state.title}
        size="xs"
        renderContent={() => <DialogContentText id="alert-dialog-description">{this.state.message}</DialogContentText>}
        renderActions={() => (
          <>
            <Button onClick={this.handleYes} variant="contained" color={this.state.type}>
              {this.state.buttonText}
            </Button>
          </>
        )}
      />
    );
  }

  public handleClose = () => {
    this.setState({ open: false });
    this.state.onAnswer(false);
  };

  public handleYes = () => {
    this.setState({ open: false });
    this.state.onAnswer(true);
  };

  public openConfirmDialog = ({
    title,
    message,
    onAnswer,
    type = 'success',
    buttonText = 'OK',
  }: ConfirmDialogProps) => {
    this.setState({ open: true, title, message, onAnswer, type, buttonText });
  };
}

export default Confirmer;
